module.exports = __webpack_public_path__ + "img/cyber.29393413.svg";